import Vue from 'vue'
import VueRouter from 'vue-router'
import module from "./module";


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
	meta: {
		title: "企业商务出行和管理平台"		
	},
	components: { 
		default:() => import('@/views/index.vue')
	}
  },  
  ...module,
]

const router = new VueRouter({
	// mode:"history",
	routes,

})

router.beforeEach((to, form, next) => {
    if (to.meta.title) {
		document.title = to.meta.title;
    }
	next();
});


router.afterEach((to,from,next) => {
	window.scrollTo(0,0);
});
export default router
